import type {AbstractNSampTestCard} from './common/abstract-nsamp-test-card';
import type {CardResult} from './card-result';
import type {Card} from './card';
import type {_AbstractPairwiseTestCard} from './common/abstract-pairwise-test-card';

/**
 * Generated from com.dataiku.dip.eda.worksheets.cards.PairwiseMoodTestCard
 */
export interface PairwiseMoodTestCard extends _AbstractPairwiseTestCard {
    // PolyJson type
    type: 'pairwise_mood';
}

export namespace PairwiseMoodTestCard {
    export const type = 'pairwise_mood';
}

/** @deprecated Use Card.isPairwiseMoodTestCard() */ export function isPairwiseMoodTestCard(toTest: Card): toTest is PairwiseMoodTestCard { return PairwiseMoodTestCard.type === toTest['type']; }

export namespace PairwiseMoodTestCard {
    /**
     * Generated from com.dataiku.dip.eda.worksheets.cards.PairwiseMoodTestCard$PairwiseMoodTestCardResult
     */
    export interface PairwiseMoodTestCardResult extends AbstractNSampTestCard._AbstractNSampleTestCardResult {
        pvalues: number[];
        statistics: number[];

        // PolyJson type
        type: 'pairwise_mood';
    }

    export namespace PairwiseMoodTestCardResult {
        export const type = 'pairwise_mood';
    }

    /** @deprecated Use CardResult.isPairwiseMoodTestCardResult() */ export function isPairwiseMoodTestCardResult(toTest: CardResult): toTest is PairwiseMoodTestCardResult { return PairwiseMoodTestCardResult.type === toTest['type']; }
}